import {useState} from 'react'
import DeleteSupplierMappingModal from '../modals/DeleteSupplierMappingModal'

const SupplierMappingTableActionsMenu = ({row: supplierMapping}: any) => {
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  return [
    {
      label: 'Remove',
      onClick: () => setShowDeleteModal(true),
      render: showDeleteModal && (
        <DeleteSupplierMappingModal
          supplierMapping={supplierMapping}
          onClose={() => setShowDeleteModal(false)}
        />
      ),
    },
  ]
}

export default SupplierMappingTableActionsMenu
